import { getPropertyType } from './property';
import { STRING } from './attribute_type';

class Cell {

	constructor(address, cell, value) {
		this.address = address;
		this.cell = cell;
		this.value = value;
	}	
	
	getValue() {
		return this.value.w;
	}
	
	isEmpty() {
		return this.value === undefined || this.value.v === undefined;
	}
		
	getType() {
		const type = getPropertyType( this.value.v );
		return type || STRING;
	}	
	
	getIndex() {
		return this.address.c;
	}
	
	getCell() {
		return this.cell;
	}
	
}

class Sheet {

	constructor(sheet, utils) {
		this.sheet = sheet;
		this.utils = utils;		
	}
	
	getCells(startIndex, numberOfLines) {
		const { decode_range, encode_cell, decode_cell } = this.utils;
	
		const createCell = (row, column) => {
			const obj = { c: column, r: row };
			return encode_cell(obj);
		}
	
		const range = this.sheet['!ref'];
		const rows = [];

		if( range ) {	
			const { s, e } = decode_range( this.sheet['!ref'] );
			
			
			for( let rowIndex = Math.max(startIndex, s.r); rowIndex <= Math.min(e.r, numberOfLines); rowIndex++ ) {		
				const row = [];
				rows.push( row );
			
				for( let columnIndex = s.c; columnIndex <= e.c; columnIndex++) {				
					const cell = createCell(rowIndex, columnIndex);				
					const value = this.sheet[cell];
					row.push(new Cell(decode_cell(cell), cell, value));
				}
			}
		}
		
		return rows;
	}		
}

class Workbook {
	
	constructor(workbook, utils) {
		this.workbook = workbook;
		this.utils = utils;
	}	
	
	getSheets() {	
		return this.workbook.SheetNames;
	}
	
	getSheet(sheetName) {
		const sheet = this.workbook.Sheets[sheetName];						
		return new Sheet(sheet, this.utils);		
	}	
}

const excel = async (reader) => {
	const buffer = await reader.read();

	const { read, utils } = await import(/* webpackChunkName: "xlsx" */ 'xlsx/xlsx.mjs');

	const workbook = read(buffer, {	
		cellDates: true
	});
		
	return new Workbook(workbook, utils);
}

export {
	excel
}